"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertSnakeCaseToTitleCase = void 0;
function convertSnakeCaseToTitleCase(string) {
    return string
        .split("_")
        .map(function (word) { return word[0].toUpperCase() + word.slice(1); })
        .join(" ");
}
exports.convertSnakeCaseToTitleCase = convertSnakeCaseToTitleCase;
